import httpClient from '../../client'

import apiRoutes from '../constants'

const lostProposal = async ({id}) => {
  return await httpClient.post(`${apiRoutes.GET_PROPOSALS}/${id}/lost`)
}

export default lostProposal
